module.exports = __webpack_public_path__ + "img/广州办公室1.33f04327.jpg";